import { useState, useCallback } from 'react';
export const useMenu = (openState = false) => {
    const [isOpenMenu, setOpenMenu] = useState(() => openState);
    const handleOpenMenu = useCallback(() => setOpenMenu(true), [setOpenMenu]);
    const handleCloseMenu = useCallback(() => setOpenMenu(false), [setOpenMenu]);
    const handleToggleMenu = useCallback(() => setOpenMenu(!isOpenMenu), [setOpenMenu, isOpenMenu]);
    return { isOpenMenu, handleOpenMenu, handleCloseMenu, handleToggleMenu };
};
